import {seasonTypes, systemTypes} from '../helpers/constants';
import round from 'lodash/round';

export function validateTemperatureCelsius(temperature, poolType, season) {
  let valid = (!!temperature || temperature === 0) && parseInt(temperature).toString() === temperature.toString();

  if (poolType === systemTypes.spa) {
    valid = valid && temperature >= 26 && temperature <= 40;
    return valid;
  }

  if (poolType === systemTypes.swimspa) {
    valid = valid && temperature >= 21 && temperature <= 37;
    return valid;
  }

  if (season === seasonTypes.inSeason) {
    valid = valid && temperature >= 21 && temperature <= 37;
  } else if (season === seasonTypes.opening) {
    valid = valid && temperature >= 21 && temperature <= 37;
  }
  return valid;

}


export function validateTemperatureFarenheit(temperature, poolType, season) {
  let valid = (!!temperature || temperature === 0) && parseInt(temperature).toString() === temperature.toString();

  if (poolType === systemTypes.pool) {

    if (season === seasonTypes.inSeason) {
      valid = valid && temperature >= 70 && temperature <= 99;
    } else if (season === seasonTypes.opening) {
      valid = valid && temperature >= 70 && temperature <= 99;
    }
    return valid;
  }

  return valid && temperature >= 70 && temperature <= 104;
}

/**
 * Get fahrenheit and change it to celsius
 * @param {float} fah  grades to convert
 * @return {float} fahrenheit grades
 */
export function fahrenheitToCelsius(fah) {
  return round((fah - 32) / 1.8);
}

/**
 * Get celsius and change it to fahrenheit
 * @param {float} cel  grades to convert
 * @return {float} celsius grades
 */
export function celsiusToFahrenheit(cel) {
  return  round(1.8 * cel + 32);
}

